import { render, staticRenderFns } from "./log.vue?vue&type=template&id=67ba2f55&scoped=true"
import script from "./log.vue?vue&type=script&lang=js"
export * from "./log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba2f55",
  null
  
)

export default component.exports